import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogisticsEmployeeService {

  baseUrl: string = `${environment.logisticsApiUrl}/employee`;

  constructor(private http: HttpClient) {

  }

  getSalesOptions(): Observable<any> {
    const url = this.baseUrl + `/findSalesOptions`;
    return this.http.get(url);
  }

}
